import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { selectCurrentSalonCurrency } from 'selectors/currentSalon.selectors';

import PopupModalContainer from 'common/PopupModal';
import ReportTableV2 from 'reports/Common/ReportTableV2';
import BarChartD3 from 'reports/DashboardReports/BarChartD3';
import { makeMonthlyTable, revenueByMonth } from 'reports/utils';

class RevenueByStylistMonthlyTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopup: true,
      revenueObj: null,
    };
  }

  componentDidMount() {
    this.chartWidth();
    window.addEventListener('resize', this.chartWidth);
    if (this.props.monthlyRevenueReport) {
      const revenueObj = revenueByMonth(
        this.props.monthlyRevenueReport.lastRequestResponse,
        this.props.selectedStylist,
      );
      const interval = setInterval(() => {
        if (revenueObj) {
          clearInterval(interval);
          this.setState({ revenueObj });
        }
      });
    }
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.monthlyRevenueReport &&
      nextProps.monthlyRevenueReport.lastRequestResponse &&
      (nextProps.monthlyRevenueReport.start_date !== this.props.monthlyRevenueReport.start_date ||
        nextProps.monthlyRevenueReport.end_date !== this.props.monthlyRevenueReport.end_date ||
        moment(nextProps.lastMonthlyDatesSelected.toDate).toISOString() !==
          moment(this.props.lastMonthlyDatesSelected.toDate).toISOString() ||
        nextProps.selectedStylist !== this.props.selectedStylist)
    ) {
      this.setState({ revenueObj: null });
      const revenueObj = revenueByMonth(nextProps.monthlyRevenueReport.lastRequestResponse, nextProps.selectedStylist);
      const interval = setInterval(() => {
        if (revenueObj) {
          clearInterval(interval);
          this.setState({ revenueObj });
        }
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.chartWidth);
  }

  closeModal = () => {
    this.setState({ showPopup: false });
  };
  chartWidth = () => {
    if (window.innerWidth >= 1024) {
      return 1024;
    }
    if (window.innerWidth >= 834) {
      return 800;
    }
    if (window.innerWidth >= 810) {
      return 780;
    }
    if (window.innerWidth >= 768) {
      return 700;
    }
    if (window.innerWidth >= 375) {
      return 360;
    }
    if (window.innerWidth <= 320) {
      return 300;
    }
    return 1023;
  };

  render() {
    const { revenueObj } = this.state;
    let dataArray = [];
    let totalTimeRange;
    const { currency } = this.props; // Добави currency от пропс или mapStateToProps

    if (revenueObj) {
      dataArray = revenueObj.dataArray;
      totalTimeRange = revenueObj.totalTimeRange;
    }

    if (
      (!revenueObj || !dataArray.length) &&
      this.state.showPopup &&
      this.props.monthlyRevenueReport &&
      this.props.monthlyRevenueReport.lastRequestResponse &&
      !Object.keys(this.props.monthlyRevenueReport.lastRequestResponse).length
    ) {
      return (
        <PopupModalContainer
          popupTitle="Sorry! No data"
          popupMessage="No data available for the selected period. Please choose a different period"
          buttonText="Ok"
          buttonCallback={this.closeModal}
        />
      );
    } else if (dataArray.length && totalTimeRange) {
      const revenueData = makeMonthlyTable(dataArray, 'Revenue', totalTimeRange.salonTotalRevenueTimeRange, currency);
      const serviceData = makeMonthlyTable(dataArray, 'Service', totalTimeRange.salonTotalServiceTimeRange, currency);
      const retailData = makeMonthlyTable(dataArray, 'Retail', totalTimeRange.salonTotalRetailTimeRange, currency);
      const noshowData = makeMonthlyTable(dataArray, 'Noshow', totalTimeRange.salonTotalNoshowTimeRange, currency);

      return (
        <div className="revenue-monthly">
          <div
            className="bar-chart-container"
            style={{ width: this.chartWidth(), height: window.innerWidth < 600 ? 430 : 580 }}
          >
            {this.props.children}
            <BarChartD3
              width={this.chartWidth()}
              height={window.innerWidth < 600 ? 400 : 550}
              margin={{ top: 110, right: 5, bottom: 30, left: 65 }}
              chartData={revenueData.chartData}
              barTitle={`Total Revenue (inc VAT) - ${this.props.selectedStylist}`}
              barSubTitle="Total Revenue for selected date range"
              isFetching={this.props.isFetching}
              allDataLoaded={this.props.allDataLoaded}
              selectedStylist={this.props.selectedStylist}
            />
          </div>

          {dataArray.length > 0 && !this.props.isFetching && (
            <>
              {revenueData.leftHeader &&
                revenueData.leftHeader.inputFields &&
                revenueData.leftHeader.inputFields.length > 0 && (
                  <ReportTableV2
                    data={revenueData}
                    title={`Total Revenue - ${this.props.selectedStylist}`}
                    startDate={moment(this.props.lastMonthlyDatesSelected.fromDate).format('D MMM YYYY')}
                    endDate={moment(this.props.lastMonthlyDatesSelected.toDate).format('D MMM YYYY')}
                  />
                )}
              {serviceData.leftHeader &&
                serviceData.leftHeader.inputFields &&
                serviceData.leftHeader.inputFields.length > 0 && (
                  <ReportTableV2
                    data={serviceData}
                    title={`Service Revenue - ${this.props.selectedStylist}`}
                    startDate={moment(this.props.lastMonthlyDatesSelected.fromDate).format('D MMM YYYY')}
                    endDate={moment(this.props.lastMonthlyDatesSelected.toDate).format('D MMM YYYY')}
                  />
                )}
              {retailData.leftHeader &&
                retailData.leftHeader.inputFields &&
                retailData.leftHeader.inputFields.length > 0 && (
                  <ReportTableV2
                    data={retailData}
                    title={`Retail Revenue - ${this.props.selectedStylist}`}
                    startDate={moment(this.props.lastMonthlyDatesSelected.fromDate).format('D MMM YYYY')}
                    endDate={moment(this.props.lastMonthlyDatesSelected.toDate).format('D MMM YYYY')}
                  />
                )}
              {noshowData.leftHeader &&
                noshowData.leftHeader.inputFields &&
                noshowData.leftHeader.inputFields.length > 0 && (
                  <ReportTableV2
                    data={noshowData}
                    title={`No-show Fees - ${this.props.selectedStylist}`}
                    startDate={moment(this.props.lastMonthlyDatesSelected.fromDate).format('D MMM YYYY')}
                    endDate={moment(this.props.lastMonthlyDatesSelected.toDate).format('D MMM YYYY')}
                  />
                )}
            </>
          )}
        </div>
      );
    }
    return null;
  }
}

const mapStateToProps = (state) => ({
  salonId: state.currentSalon.id,
  lastDatesSelected: state.reports.lastDatesSelected,
  lastMonthlyDatesSelected: state.reports.lastMonthlyDatesSelected,
  currency: selectCurrentSalonCurrency(state),
});

const RevenueByStylistMonthlyTableHoc = connect(mapStateToProps)(RevenueByStylistMonthlyTable);

export default RevenueByStylistMonthlyTableHoc;
